// extracted by mini-css-extract-plugin
module.exports = {"borderBottomTransparent":"styles-module__borderBottomTransparent___1cva1","borderBottomDarkPrimary":"styles-module__borderBottomDarkPrimary___HOcuE"};